import { createStore } from '@stencil/store';
import { IStore } from '../types';

const shouldUpdate = (newValue: any, oldValue: any) => {
  return JSON.stringify(newValue) !== JSON.stringify(oldValue);
};


const state = createStore<IStore>(
  {
    contentStreamLimit: 5,
    inputStreamLimit: 5,
    misearch: [],
    rss: [],
    tag: [],
    broadcast: [],
    news: [],
    social: [],
    mediaList: [],
    companyLabels: [],
    suggestedInputs: [],
    globalDateRange: {},
    user: { timezone: '', language: '' },
    savedSearchIds: [],
    applets: {},
    streamOrder: [0, 1, 2, 3, 4],
    nextNamespace: 0,
    nextIndex: 0,
    inputTypes: [
      { type: 'misearch', title: 'Explore search' },
      { type: 'news', title: 'News' },
      { type: 'social', title: 'Social' },
      { type: 'broadcast', title: 'Broadcast' },
      { type: 'rss', title: 'Rss feeds' },
      { type: 'tag', title: 'Tags' },
      { type: 'mediaList', title: 'Media Lists' },
    ],
    contentStreams: [],
    sessionSplits: [],
    recentMonitors: [],
    savedMonitors: [],
    inputFavorites: [],
    monitorFavorites: [],
    activeMonitor: {},
    isNewSearch: false,
    monitorsPromiseFailure: false,
    contentStreamsUpdated: false,
    sinceLastViewedSelected: false,
  },
  shouldUpdate
);

export default state;
